const authActions = {
    SET_PROFILE_SUMMARY:'SET_PROFILE_SUMMARY',
    GET_PROFILE_SUMMARY:'GET_PROFILE_SUMMARY',
    GET_MOBILE_VERIFIED:'GET_MOBILE_VERIFIED',
    SET_MOBILE_VERIFIED:'SET_MOBILE_VERIFIED',
    VERIFY_OTP:'VERIFY_OTP',
     SET_OTP_VERIFIED: "SET_OTP_VERIFIED",
    GET_ALL_MENU:'GET_ALL_MENU',
    SET_ALL_MENU:'SET_ALL_MENU',
    CHECK_MOBILE_VERIFIED:'CHECK_MOBILE_VERIFIED',
    SET_OTP_VERIFICATION_COUNT:"SET_OTP_VERIFICATION_COUNT",
    SET_OTP_VERIFICATION_COUNT_EXCEED:"SET_OTP_VERIFICATION_COUNT_EXCEED",
    CANDIDATE_LOGIN:'CANDIDATE_LOGIN',
    CANDIDATE_LOGOUT:'CANDIDATE_LOGOUT',
    CANDIDATE_FORGETPASSWORD:'CANDIDATE_FORGETPASSWORD',
    CANDIDATE_TOKEN_VERIFY: 'CANDIDATE_TOKEN_VERIFY',
    SET_CANDIDATE_TOKEN_DETAILS: 'SET_CANDIDATE_TOKEN_DETAILS',
    CHECK_DUPLICATE_EMAIL_OR_MOBILENO: 'CHECK_DUPLICATE_EMAIL_OR_MOBILENO',

    VERIFY_EMAILID_FOR_SIGNUP: 'VERIFY_EMAILID_FOR_SIGNUP',
    VERIFY_MOBILENO_FOR_SIGNUP: 'VERIFY_MOBILENO_FOR_SIGNUP',
    SEND_OTP_FOR_MOBILE_VERIFICATION: 'SEND_OTP_FOR_MOBILE_VERIFICATION',
    CHECK_EMAIL_VERIFICAITON: 'CHECK_EMAIL_VERIFICAITON',
    RESEND_EMAIL_FOR_VERIFICATION: 'RESEND_EMAIL_FOR_VERIFICATION',
    CHECK_CANDIDATE_MOBILENO: 'CHECK_CANDIDATE_MOBILENO',
    FORGOTPASSWORD_MOBILEVERIFICATION: 'FORGOTPASSWORD_MOBILEVERIFICATION',
    FORGOTPASSWORD_MOBILEVERIFICATION_SENDMAILID: 'FORGOTPASSWORD_MOBILEVERIFICATION_SENDMAILID',
    CHANGE_PASSWORD:'CHANGE_PASSWORD',
    FORGOTMAIL_OTP_VERIFY:'FORGOTMAIL_OTP_VERIFY',
    
    GET_PROFILE_REGISTRATION_ACTIVE_TAB: 'GET_PROFILE_REGISTRATION_ACTIVE_TAB',
    SET_PROFILE_REGISTRATION_ACTIVE_TAB: 'SET_PROFILE_REGISTRATION_ACTIVE_TAB',
    CANDIDATE_RESET_PASSWORD: 'CANDIDATE_RESET_PASSWORD',
    CANDIDATE_FORGET_EMAILID: 'CANDIDATE_FORGET_EMAILID',

    CHECK_KEYCLOAK_SID : 'CHECK_KEYCLOAK_SID',
    GET_TEMP_CANDIDATE_DETAILS:'GET_TEMP_CANDIDATE_DETAILS',
    SET_TEMP_CANDIDATE_DETAILS:'SET_TEMP_CANDIDATE_DETAILS',
    AADHAR_INITIATE:"AADHAR_INITIATE",
    SET_AADHAR_INITIATE:"SET_AADHAR_INITIATE",
    GET_CALL_BACK_API_FOR_AADHAR:"GET_CALL_BACK_API_FOR_AADHAR",
    SET_CALL_BACK_API_FOR_AADHAR:"SET_CALL_BACK_API_FOR_AADHAR",
    SET_APPAR_MANDATORY_DIALOG:'SET_APPAR_MANDATORY_DIALOG',


};

export default authActions;